import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivites = (props) => /* @__PURE__ */ _jsx("svg", {
	name: "activities",
	viewBox: "0 -10 400 164",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "puzzle-shadow",
				d: "M199.474 133.667h-43.638c-3.784 0-6.593-3.195-6.593-6.971V99.199c0-9.238-7.725-11.293-13.088-6.569-8.83 7.782-22.38 3.613-22.972-10.546.593-14.158 14.076-18.324 22.907-10.543 5.367 4.724 13.153 2.668 13.153-6.57V37.472c0-3.775 2.81-6.473 6.593-6.473h88.328c3.784 0 6.593 2.698 6.593 6.473V64.97c0 9.239 7.786 11.295 13.153 6.57 8.83-7.78 22.314-3.614 22.907 10.544-.593 14.159-14.142 18.328-22.972 10.546-5.363-4.724-13.088-2.67-13.088 6.569v27.497c0 3.776-2.81 6.97-6.593 6.97h-44.69z",
				fillOpacity: .16,
				fill: "#000"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "puzzle-piece",
				d: "M199.474 102.667h-43.638c-3.784 0-6.593-3.195-6.593-6.971V68.199c0-9.238-7.725-11.293-13.088-6.569-8.83 7.782-22.38 3.613-22.972-10.546.593-14.158 14.076-18.324 22.907-10.543 5.367 4.724 13.153 2.668 13.153-6.57V6.472c0-3.775 2.81-6.473 6.593-6.473h88.328c3.784 0 6.593 2.698 6.593 6.473V33.97c0 9.239 7.786 11.295 13.153 6.57 8.83-7.78 22.314-3.614 22.907 10.544-.593 14.159-14.142 18.328-22.972 10.546-5.363-4.724-13.088-2.67-13.088 6.569v27.497c0 3.776-2.81 6.97-6.593 6.97h-44.69z",
				fill: "#FFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M400 57.807c0-3.776-2.81-6.474-6.596-6.474h-89.42c-3.784 0-6.878 2.698-6.878 6.474V85.87c0 1.646.74 4.416 2.32 5.151 1.572.73 3.605-.032 5.277-1.552 5.14-4.677 12.045-5.98 17.907-3.406 5.891 2.591 9.977 8.679 9.977 16.282 0 7.802-4.134 13.831-10.055 16.433-5.926 2.602-12.862 1.204-18.021-3.489-1.653-1.506-3.592-2.225-5.104-1.524-1.552.724-2.3 3.372-2.3 5.019v28.245c0 3.776 3.093 6.971 6.877 6.971h89.42c3.786 0 6.596-3.195 6.596-6.97V57.806zM0 57.807c0-3.776 2.81-6.474 6.596-6.474h89.42c3.784 0 6.878 2.698 6.878 6.474V85.87c0 1.646-.74 4.416-2.32 5.151-1.572.73-3.605-.032-5.277-1.552-5.14-4.677-12.045-5.98-17.907-3.406-5.891 2.591-9.977 8.679-9.977 16.282 0 7.802 4.134 13.831 10.055 16.433 5.926 2.602 12.862 1.204 18.021-3.489 1.653-1.506 3.592-2.225 5.104-1.524 1.552.724 2.3 3.372 2.3 5.019v28.245c0 3.776-3.093 6.971-6.877 6.971H6.596C2.81 154 0 150.805 0 147.03V57.806z",
				fill: "#FFF",
				opacity: .4
			})
		]
	})
});
export default SvgActivites;
